import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAdminUser, getUserTypeName } from "./adminNavigation";
import CustomerDashboardLayout from "../../components/customer/CustomerDashboardLayout";
import PartnerDashboardLayout from "../../components/partner/PartnerDashboardLayout";

const AdminRouteLayout = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const location = useLocation();
  const content = children ?? <Outlet />;

  if (!isAdminUser(authState)) {
    const userType = getUserTypeName(authState);
    const isPartner =
      userType === "PARTNER" || location.pathname.startsWith("/partner");

    if (isPartner) {
      return <PartnerDashboardLayout>{content}</PartnerDashboardLayout>;
    }

    return <CustomerDashboardLayout>{content}</CustomerDashboardLayout>;
  }

  return content;
};

export default AdminRouteLayout;
